import { Formik, Form, Field } from "formik";
import { Form as FormBootstrap } from "react-bootstrap";
import { Button, Col, Row } from "react-bootstrap";
import moment from "moment";
import CustomDatePicker from "../../../../CustomDatePicker";
import useFilterBots from "./hooks/useFilterBots";
import { defaultFormat } from "../../../../../util/date";

const FilterBots = ({ setFilters, practiceId, theme }) => {
  const { filter, handleSetFilter, handleReset } = useFilterBots(
    setFilters,
    practiceId,
  );

  return (
    <Formik
      initialValues={filter}
      onSubmit={(values) => {
        handleSetFilter(values);
      }}
      enableReinitialize={true}
    >
      {({ values, setFieldValue }) => (
        <Form className="mt-3">
          <Row>
            <Col>
              <label htmlFor="botName">Bot Name</label>
              <Field
                className="form-control"
                id="botName"
                name="botName"
                value={values.botName}
                onChange={({ target: { value } }) => {
                  setFieldValue("botName", value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <label htmlFor="code">Code</label>
              <Field
                className="form-control"
                id="code"
                name="code"
                value={values.code}
                onChange={({ target: { value } }) => {
                  setFieldValue("code", value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <label htmlFor="startDate">Start date</label>
              <CustomDatePicker
                id="startDate"
                name="startDate"
                onChange={(date) => {
                  setFieldValue("startDate", date);
                }}
                value={
                  values.startDate
                    ? moment(values.startDate, defaultFormat).toDate()
                    : null
                }
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <label htmlFor="endDate">End date</label>
              <CustomDatePicker
                id="endDate"
                name="endDate"
                onChange={(date) => {
                  setFieldValue("endDate", date);
                }}
                value={
                  values.endDate
                    ? moment(values.endDate, defaultFormat).toDate()
                    : null
                }
              />
            </Col>
          </Row>
          <FormBootstrap.Group className="m-2 text-center">
            <Button
              type="submit"
              className={`${theme.hoverPrimaryClassButton} mt-3`}
              style={{ backgroundColor: theme.primary }}
            >
              Apply filters
            </Button>

            <Button
              type="button"
              className={`${theme.hoverSecondaryClassButton} mt-3 ml-1`}
              style={{ backgroundColor: theme.secondary, color: theme.black }}
              onClick={handleReset}
            >
              Reset
            </Button>
          </FormBootstrap.Group>
        </Form>
      )}
    </Formik>
  );
};

export default FilterBots;
